import React from "react";
import { ListGroup, ListGroupItem, Badge, Spinner } from "reactstrap";
import { AUTOMATION_CATEGORIES } from "../../../../models/automation";

/**
 * AutomationSidebar
 * Sidebar com as categorias de automação, mostrando quantos estão ativos em cada.
 */
const AutomationSidebar = ({ triggers, activeCategoryId, onSelectCategory, loading }) => {

    if (loading) {
        return (
            <div className="border-0 bg-white h-100 overflow-hidden rounded-0">
                <div className="text-center py-5">
                    <Spinner color="primary" size="sm" />
                    <p className="text-muted small mt-2">Carregando...</p>
                </div>
            </div>
        );
    }

    // Contar ativos por categoria
    const countByCategory = {};
    const totalByCategory = {};
    AUTOMATION_CATEGORIES.forEach(cat => {
        countByCategory[cat.id] = 0;
        totalByCategory[cat.id] = 0;
    });
    triggers.forEach(t => {
        if (totalByCategory[t.category] !== undefined) totalByCategory[t.category]++;
        if (t.active && countByCategory[t.category] !== undefined) countByCategory[t.category]++;
    });

    return (
        <div className="border-0 bg-white h-100 overflow-hidden rounded-0 d-flex flex-column">
            <div className="border-bottom py-3 px-4">
                <div className="d-flex align-items-start overflow-hidden">
                    <i className="mdi mdi-robot-outline text-primary font-size-22 me-2 mt-1"></i>
                    <div className="overflow-hidden">
                        <h6 className="mb-0 fw-bold text-dark text-truncate">Automações</h6>
                        <p className="text-muted small mb-0 text-truncate">
                            {triggers.filter(t => t.active).length} de {triggers.length} ativas
                        </p>
                    </div>
                </div>
            </div>

            <ListGroup flush className="flex-grow-1 overflow-auto custom-scrollbar">
                {AUTOMATION_CATEGORIES.map(cat => {
                    const isActive = activeCategoryId === cat.id;
                    const activeCount = countByCategory[cat.id];
                    const total = totalByCategory[cat.id];

                    return (
                        <ListGroupItem
                            key={cat.id}
                            tag="button"
                            action
                            onClick={() => onSelectCategory(cat.id)}
                            className={`border-0 py-3 px-4 d-flex align-items-center justify-content-between transition-all select-none cursor-pointer ${isActive ? 'bg-primary bg-opacity-10' : 'hover-bg-light'}`}
                            style={{
                                borderLeft: isActive ? "4px solid var(--bs-primary)" : "4px solid transparent",
                                borderRadius: 0
                            }}
                        >
                            <div className="d-flex align-items-center flex-grow-1 overflow-hidden">
                                <div className="flex-shrink-0 me-3">
                                    <i className={`mdi ${cat.icon} font-size-20 ${isActive ? 'text-primary' : 'text-secondary'}`} style={{ marginTop: '2px' }}></i>
                                </div>
                                <div className="text-start overflow-hidden">
                                    <h6 className={`mb-0 fw-semibold text-truncate font-size-14 ${isActive ? 'text-primary' : 'text-dark'}`}>
                                        {cat.id}
                                    </h6>
                                    <span className="text-muted small" style={{ fontSize: '11px' }}>
                                        {total} gatilho{total !== 1 ? 's' : ''}
                                    </span>
                                </div>
                            </div>

                            {activeCount > 0 && (
                                <Badge
                                    color="success"
                                    pill
                                    className="bg-opacity-10 text-success font-size-10 px-2 rounded-0"
                                    style={{ backgroundColor: 'transparent' }}
                                >
                                    {activeCount} ativa{activeCount !== 1 ? 's' : ''}
                                </Badge>
                            )}
                        </ListGroupItem>
                    );
                })}
            </ListGroup>
        </div>
    );
};

export default AutomationSidebar;
